import Privilege from "./Privilege/Privilege";
import React from "react";
class AtriaUserDetails extends React.Component {
  constructor() {
    super();

    this.state = {
      activeMenu: "Privilege"
    };

    this.changeMenu = this.changeMenu.bind(this);
  }

  changeMenu(e, menu) {
    e.preventDefault();

    this.setState({ activeMenu: menu });
  }

  render() {
    const { activeMenu } = this.state;
    const userId = this.props.user.userId;
    const user = this.props.user;
    const accessSpecifier = this.props.accessSpecifier;
    return (
      <div className="tab-style-1">
        <div
          className="nav flex-column nav-pills"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
          style={{ minHeight: "688px" }}
        >
          <a
            className={
              activeMenu === "Privilege" ? "nav-link active" : "nav-link"
            }
            id="specs-tab"
            data-toggle="pill"
            href="#specs"
            role="tab"
            aria-controls="specs"
            aria-selected="true"
            onClick={e => {
              this.changeMenu(e, "Privilege");
            }}
          >
            Privileges
          </a>
        </div>

        <div className="tab-content" id="v-pills-tabContent">
          {activeMenu === "Privilege" ? (
            <Privilege
              userId={userId}
              user={user}
              accessSpecifier={accessSpecifier}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default AtriaUserDetails;
